/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step6_ArtifactInputs */

const en_dr_step6_artifact = /** @type {(inputs: Dr_Step6_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chosen solution + hypotheses → wizard draft, 7 answers, first acceptance criteria`)
};

const id_dr_step6_artifact = /** @type {(inputs: Dr_Step6_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solusi terpilih + hipotesis → draft wizard, 7 jawaban, kriteria penerimaan awal`)
};

/**
* | output |
* | --- |
* | "Chosen solution + hypotheses → wizard draft, 7 answers, first acceptance criteria" |
*
* @param {Dr_Step6_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step6_artifact = /** @type {((inputs?: Dr_Step6_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step6_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step6_artifact(inputs)
	return en_dr_step6_artifact(inputs)
});